import type { SVGProps } from "react";
const SvgCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <defs>
      <linearGradient
        id="check_svg__a"
        x1={7.38}
        x2={24.62}
        y1={7.38}
        y2={24.62}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#61d18d" />
        <stop offset={1} stopColor="#4ea974" />
      </linearGradient>
    </defs>
    <path
      fill="url(#check_svg__a)"
      d="M16 3.8a12.2 12.2 0 1 0 0 24.4 12.2 12.2 0 0 0 0-24.4"
    />
    <path
      fill="#fff"
      d="m20.56 12.06-5.75 5.75-3.37-3.37a1 1 0 1 0-1.42 1.42l4.08 4.08a1 1 0 0 0 1.42 0l6.46-6.46a1 1 0 0 0-1.42-1.42"
    />
  </svg>
);
export default SvgCheck;
